import './index.scss'
import LogoG from '../../../assets/images/log_gL2.png'
import LogoW from '../../../assets/images/logo_sub-v3.png'
import { useEffect, useRef } from 'react'
// import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin'
import gsap from 'gsap-trial'

const Logo = () => {
  const bgRef = useRef()
  const outlineLogoRef = useRef()
  const solidLogoRef = useRef()
  const solidLogoWRef = useRef()

  useEffect(() => {
    // gsap.registerPlugin(DrawSVGPlugin)

    gsap.timeline()
    //   .to(bgRef.current, {
    //     duration: 1,
    //     opacity: 1,
    //   })
    //   .fromTo(
    //     outlineLogoRef.current,
    //     {
    //       duration: 15,
    //       drawSVG: '0%',
    //     },
    //     {
    //       duration: 15,
    //       drawSVG: '0% 100% ',
    //     }
    //   )
    gsap.fromTo(
      solidLogoRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        delay: 3,
        duration: 2,
      }
    )
  }, [])

  return (
    <div className="logo-container" ref={bgRef}>
      <img
        ref={solidLogoRef}
        className="solid-logo"
        src={LogoG}
        alt="JavaScript, Developer"
      />
      <svg
        width="234.20065mm"
        height="275.75858mm"
        viewBox="0 0 234.20065 275.75858"
        version="1.1"
        id="svg65"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          className="svg-container"
          transform="translate(-0.56768612,4.8392433)"
          fill="none"
        >
          <path
            ref={outlineLogoRef}
            d="m 234.63367,119.5495 -3.79895,15.40971 m 3.79895,92.15567 -3.79895,15.40971 m -31.47735,-95.11882 -3.79893,15.4097 m 3.79893,51.88157 -3.79893,15.4097 m -54.40692,-82.70097 -3.79894,15.4097 m 3.79894,-43.26597 -3.79894,15.40971 m 90.4022,-79.680447 -3.79891,15.409725 m 3.79891,-51.488597 -3.79891,15.409723 M 195.55844,230.10674 c 0,-22.43042 0,-44.86084 0,-67.29127 -19.40191,0 -38.80389,0 -58.20586,0 0,-9.28542 0,-18.57085 0,-27.85626 31.16074,0 62.32142,0 93.48216,0 0,35.85513 0,71.71026 0,107.56538 -40.74026,27.62715 -94.74952,34.36984 -142.735629,22.96834 C 51.545196,256.77731 21.071235,229.46877 9.5201538,195.37037 -1.7592979,162.26444 -1.9743811,125.82349 7.4841878,92.295159 17.497953,56.689951 47.461405,26.867395 84.921488,16.903379 131.08769,4.7100253 183.04806,10.455178 223.95588,34.609615 c 0,12.026289 0,24.05258 0,36.078873 C 191.95689,43.777512 146.53272,32.464353 104.84466,41.670857 77.56126,46.726851 54.349145,66.326818 46.048333,91.595078 36.187858,120.908 36.088075,153.05991 43.712143,182.84944 c 6.476862,25.5919 26.760802,48.01247 53.827852,55.09648 26.601655,7.04853 55.657855,6.71027 82.075245,-0.9695 5.52967,-1.79492 10.89239,-4.07127 15.9432,-6.86968 z m 3.79893,-15.4097 c 0,-22.43042 0,-44.86085 0,-67.29127 -19.40191,0 -38.80388,0 -58.20585,0 0,-9.28542 0,-18.57084 0,-27.85627 31.16072,0 62.32142,0 93.48215,0 0,35.85514 0,71.71025 0,107.56538 -40.74024,27.62715 -94.74953,34.36984 -142.735626,22.96834 C 55.34413,241.36755 24.870169,214.05905 13.319089,179.96062 2.0396351,146.85474 1.8245518,110.41375 11.283119,76.885447 21.296882,41.280231 51.26034,11.457674 88.720419,1.4936572 134.88662,-10.699694 186.84697,-4.954539 227.75478,19.199892 c 0,12.026293 0,24.052584 0,36.078873 C 195.75583,28.36779 150.33165,17.054634 108.6436,26.261131 81.360192,31.317129 58.148078,50.9171 49.847268,76.185366 c -9.860475,29.312884 -9.960259,61.464844 -2.336195,91.254344 6.476866,25.59193 26.760802,48.01249 53.827857,55.09647 26.60167,7.04854 55.65786,6.71029 82.07521,-0.96948 5.52971,-1.7949 10.89243,-4.07128 15.94323,-6.86966 z"
          />
        </g>
      </svg>

      <img
        ref={solidLogoWRef}
        className="solid-logoW"
        src={LogoW}
        alt="Wolfinger"
      />
    </div>
  )
}

export default Logo
